import styled from "styled-components";

export const SuggestionListWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing(1.5)};
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
`;

export const FixedContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
`;

export const SectionTitle = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  padding-left: ${({ theme }) => theme.spacing(1)};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.mediumGray};
`;

export const ContainerDivisor = styled.div`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors.disabledGray};
`;

export const ScrollableContainer = styled.div`
  border-top: 0px solid ${({ theme }) => theme.colors.disabledGray};
  padding-top: ${({ theme }) => theme.spacing(0.75)};
  max-height: ${({ theme }) => theme.spacing(30)};
  display: flex;
  overflow-y: auto;

  scrollbar-color: ${({ theme }) => theme.colors.vividBlue}
    ${({ theme }) => theme.colors.lightGray};
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: ${({ theme }) => theme.spacing(1)};
    background: ${({ theme }) => theme.colors.lightGray};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.vividBlue};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;

export const Column = styled.div`
  flex-direction: column;
  min-width: 50%;
  display: flex;
  flex: 1;
`;

export const ColumnTitle = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  padding-bottom: ${({ theme }) => theme.spacing(0.75)};
  padding-left: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.mediumGray};
  font-size: 1rem;
  gap: ${({ theme }) => theme.spacing(0.5)};
  justify-content: flex-start;
  align-items: center;
  display: flex;

  & > svg {
    font-weight: ${({ theme }) => theme.fontWeights.extraLight};
    font-size: ${({ theme }) => theme.fontSizes.md};
    color: ${({ theme }) => theme.colors.vividBlue};
  }
`;

export const FixedList = styled.div`
  gap: ${({ theme }) => theme.spacing(0.5)};
  grid-template-columns: 1fr;
  display: grid;
`;

export const ScrollableList = styled.div`
  gap: ${({ theme }) => theme.spacing(0.5)};
  flex-direction: column;
  display: flex;
  flex: 1;
`;
